import SpecialPriceServices from "@/services/SpecialPriceServices.js";

export default {
  getSpecialPriceDetails: SpecialPriceServices.getDetails,
  getSpecialPriceList: SpecialPriceServices.getList,
  postSpecialPrice: SpecialPriceServices.postData,
  putSpecialPrice: SpecialPriceServices.putData
}